// Tiny helper for "x m ago" style relative timestamps used by news cards.
// Returns short forms: 'just now', '3m ago', '2h ago', '4d ago', or a fallback date.
export function relativeTime(input) {
  if (!input) return "";
  let t;
  if (typeof input === "number") {
    // Allow both unix seconds and ms
    t = input < 1e12 ? input * 1000 : input;
  } else {
    const d = new Date(input);
    if (isNaN(d.getTime())) return "";
    t = d.getTime();
  }
  const diff = Math.max(0, Date.now() - t);
  const sec = Math.floor(diff / 1000);
  if (sec < 45) return "just now";
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d ago`;
  return new Date(t).toLocaleDateString();
}
